import React from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert } from "flowbite-react";
import { FaRegThumbsDown, FaRegThumbsUp } from "react-icons/fa6";
import { getImageURLScore } from "../../../utils/utils";

// Cor com base em thresholds
const getColorClass = (value, thresholds) => {
  if (value >= thresholds.green) return "text-green-600";
  if (value >= thresholds.yellow) return "text-yellow-500";
  return "text-red-600";
};

// Texto explicativo do Rating Bacen
const getRatingDescription = (rating) => {
  switch (rating) {
    case "AA":
      return "Perfil empresarial de risco mínimo.";
    case "A":
      return "Bom perfil de crédito. Baixo risco de inadimplência.";
    case "B":
      return "Risco moderado. Manter atenção ao histórico financeiro.";
    case "C":
      return "Risco considerável. Requer análise detalhada.";
    case "D":
    case "E":
    case "F":
    case "G":
      return "Alto risco de crédito. Sugere restrição na concessão.";
    case "H":
      return "Operação com risco de prejuízo. Crédito não recomendado.";
    default:
      return "Classificação não informada.";
  }
};

const ScorePJQuery = ({ data }) => {
  return (
    <>
      <TitleStripe>Score de crédito PJ</TitleStripe>

      {data?.statusRetorno == 1 ? (
        <div className="grid grid-cols-3 gap-4 mt-3">
          <div className="bg-white rounded-2xl border border-gray-300 p-6 grid grid-cols-1 md:grid-cols-2 gap-6 col-span-2">
            {/* SCORE */}
            <div>
              <p className="text-sm text-gray-500">Score</p>
              <p
                className={`text-4xl font-bold ${getColorClass(data?.score, {
                  green: 800,
                  yellow: 600,
                })}`}
              >
                {data.score}
              </p>
            </div>

            {/* RATING BACEN */}
            <div>
              <p className="text-sm text-gray-500">Rating Bacen</p>
              <p className="text-2xl font-semibold text-blue-700">
                {data.ratingBACEN}
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Probabilidade de inadimplência:{" "}
                <span
                  className={`font-medium ${getColorClass(
                    data.probabilidadeInadimplencia,
                    { green: 0, yellow: 11 }
                  )}`}
                >
                  {data.probabilidadeInadimplencia}%
                </span>
              </p>
            </div>

            {/* CAPACIDADE DE PAGAMENTO */}
            <div>
              <p className="text-sm text-gray-500">Capacidade de Pagamento</p>
              <p
                className={`text-lg font-semibold ${getColorClass(
                  data.capacidadePagamento,
                  { green: 80, yellow: 50 }
                )}`}
              >
                {data.capacidadePagamento}%
              </p>
            </div>

            {/* CONCESSÃO DE CRÉDITO */}
            <div>
              <p className="text-sm text-gray-500">Concessão de Crédito</p>
              <div className="flex items-center gap-2 mt-1">
                {data.concessaoCredito ? (
                  <>
                    <FaRegThumbsUp className="text-green-600 w-5 h-5" />
                    <span className="text-green-600 font-medium">
                      Recomendada
                    </span>
                  </>
                ) : (
                  <>
                    <FaRegThumbsDown className="text-red-600 w-5 h-5" />
                    <span className="text-red-600 font-medium">
                      Não Recomendada
                    </span>
                  </>
                )}
              </div>
            </div>

            {/* CAPITAL SOCIAL */}
            <div>
              <p className="text-sm text-gray-500">Capital Social</p>
              <p className="text-md text-gray-800 font-semibold">
                R$ {data.capitalSocial.toLocaleString()}
              </p>
            </div>

            {/* FATURAMENTO PRESUMIDO */}
            <div>
              <p className="text-sm text-gray-500">Faturamento Presumido</p>
              <p className="text-md text-gray-800 font-semibold">
                {data.faturamentoPresumidoAnual}
              </p>
            </div>

            {/* QUADRO DE FUNCIONÁRIOS */}
            <div>
              <p className="text-sm text-gray-500">Quadro de Funcionários</p>
              <p className="text-md text-gray-800 font-semibold">
                {data.quadroFuncionarios}
              </p>
            </div>
          </div>

          {/* COLUNA DE DESTAQUE VISUAL (OPCIONAL) */}
          <div className="bg-white rounded-2xl border border-gray-300 p-4 flex flex-col items-center justify-center">
            <img className="w-full" src={`${getImageURLScore(+data?.score)}`} />
            <p
              className={`text-5xl font-bold ${getColorClass(data?.score, {
                green: 800,
                yellow: 600,
              })}`}
            >
              {data.score}
            </p>
            <p className="text-sm text-gray-500 mt-2">Score da empresa</p>
          </div>
        </div>
      ) : (
        <Alert withBorderAccent color="gray" className="mt-4">
          Consulta Indisponível no momento
        </Alert>
      )}
    </>
  );
};

export default ScorePJQuery;
